<script lang="ts">
  import { css, cx } from '@agapi/ui/panda/css';

  import { Badge } from '../../badge';
  import { selectStyles } from '../select.styles';
  import { useSelectContext } from '../use-select-context';
  import { CaretDown } from 'phosphor-svelte';
  import { visuallyHidden } from '@agapi/ui/panda/patterns';
  import type { SelectControlProps } from '../select.types';

  const classes = selectStyles();
  const { trigger: triggerStyles, control: controlStyles } = selectStyles.raw();

  const { triggerLabel, badge, buttonStyles, controlStyles: customControlStyles, labelStyles, ...controlProps }: SelectControlProps = $props();
  const select = useSelectContext();
</script>

<div {...select.api.getControlProps()} {...controlProps} class={css(controlStyles, customControlStyles)}>
  <!-- svelte-ignore a11y_label_has_associated_control -->

  <label {...select.api.getLabelProps()} class={cx(classes.label, visuallyHidden())}>Label</label>
  <button {...select.api.getTriggerProps()} aria-expanded={select.api.open} class={css(triggerStyles, buttonStyles)}>
    {#if labelStyles}
      <span class={css(labelStyles)}>
        {triggerLabel}
      </span>
    {:else}
      {triggerLabel}
    {/if}

    {#if select.api.getHiddenSelectProps().multiple && badge}
      <Badge
        size="sm"
        css={{ mr: 'auto', minWidth: '24px' }}
        style="opacity: {select.api.hasSelectedItems ? 1 : 0}"
      >
        {select.api.value.length}
      </Badge>
    {/if}
    <span {...select.api.getIndicatorProps}>
      <CaretDown width={14} {...select.api.getIndicatorProps} class={classes.indicator} />
    </span>
  </button>
</div>
